<template>
	<div class="batch-update">
		<div class="formd-header">
			{{$t('terminal.upType')}} <el-radio v-model="updateType" label="2" class="rad">{{$t('terminal.localUp')}}</el-radio>
		</div>
		<div v-if="updateType==2" class="upd">
			<el-upload class="upload-demo" :headers="MyHeader" action="/api/admin/device/uploadUpdatePackage"
				accept=".zip, .apk" :limit="1" :data='uploadFile' :before-upload="handlePreview"
				:on-success="handle_success" :on-remove="handleRemove">
				<el-button size="small" type="primary">{{$t('terminal.clickUp')}}</el-button>
			</el-upload>
		</div>
		<el-table :data="updateData" height="350px">
			<el-table-column prop="name" :label="$t('terminal.name')" width="180">
			</el-table-column>
			<el-table-column prop="model" :label="$t('terminal.type')" width="100">
				<template slot-scope="scope">
					<div v-if="scope.row.model">{{scope.row.model}}</div>
					<div v-else> -- </div>
				</template>
			</el-table-column>
			<el-table-column prop="system_version" :label="$t('terminal.verInfo')" width="220">
				<template slot-scope="scope">
					<template v-if="scope.row.system_version">
						<el-tooltip class="item" effect="dark" :content="`${scope.row.system_version} -> ${local_new_version}`" placement="top">
							<div style="width: 100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{scope.row.system_version }}  ->  {{local_new_version}}</div>
						</el-tooltip>
					</template>
					<template v-else>
						--
					</template>
				</template>
			</el-table-column>
			<el-table-column prop="run_state" :label="$t('terminal.status')" width="180">
				<template slot-scope="scope">
					<div :style="'color:' + scope.row.runStateInfo.stateColor">{{$t(scope.row.runStateInfo.stateName)}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="progress" :label="$t('terminal.schedule')" width="180">
				<template slot-scope="scope">
					<template v-if="showFlag == 'zip'">
						<template v-if="!scope.row.status">
							<div>{{$t('terminal.waitStar')}}</div>
						</template>
						<template v-else-if="scope.row.status == 0">
							{{$t('terminal.downExc')}}
						</template>
						<template v-else-if="scope.row.status == 1">
							{{$t('terminal.downOK')}}
						</template>
						<template v-else-if="scope.row.status == 2">
							{{$t('terminal.upTip')}}
						</template>
						<template v-else-if="scope.row.status == 3">
							{{$t('terminal.erroBack')}}
						</template>
						<template v-else-if="scope.row.status == 4">
							<el-progress :percentage="scope.row.percent"></el-progress>
						</template>
					</template>
					<template v-else-if="showFlag == 'apk'">
						<template v-if="!scope.row.status">
							<div>{{$t('terminal.waitStar')}}</div>
						</template>
						<template v-if="scope.row.status == 0">
							{{$t('terminal.downExc')}}
						</template>
						<template v-if="scope.row.status == 2">
							{{$t('terminal.erroBack')}}
						</template>
						<template v-if="scope.row.status == 3">
							{{$t('terminal.downOK')}}
						</template>
						<template v-if="scope.row.status == 4 || scope.row.status == 5">
							{{scope.row.message}}
						</template>
						<template v-if="scope.row.status == 1">
							<div style="width: 95%;">
								<el-progress :percentage="scope.row.percent"></el-progress>
							</div>
						</template>
					</template>
					<template v-else>
						<div>{{$t('terminal.waitStar')}}</div>
					</template>
				</template>
			</el-table-column>
		</el-table>
		<div class="footer">
			<div class="bt-group">
				<!-- <el-button @click="cancel" round>取消</el-button> -->
				<span style="margin-left: 50px;color: #617883;">{{$t('terminal.upTips1')}}<span
						style="color: red;">{{$t('terminal.upTips2')}}</span> </span>
				<el-button type="primary" round @click="confirm" :disabled="!localUrl">{{$t('terminal.upGr')}}</el-button>
			</div>
			
		</div>
	</div>
</template>

<script>
	import {
		handleDataAndSign
	} from "@/assets/scripts/handleDataAndSign";
	import {
		sendCommandKp
	} from "@/assets/scripts/publicFunction";
	export default {
		name: "BatchUpdate",
		props: {
			tableData: {
				type: Array
			}
		},
		data() {
			return {
				updateData: [],
				updateType: "2",
				MyHeader: {},
				uploadFile: {},
				localUrl: "",
				local_new_version: "",
				fileSize: 0,
				showFlag:""
			}
		},
		methods: {
			cancel(){
				this.$emit("closeDialog")
			},
			confirm() {
				let upurl = this.localUrl
				let type = upurl.slice(upurl.length - 3, upurl.length);
				this.showFlag = type;
				let sendDeviceArr = [];
				let updateMethod = "";
				this.updateData.forEach(ele=>{
					let dcObj = {
						id: ele.id,
						sn: ele.sn,
						type_id: ele.type_id,
						name: ele.name,
						myData: {
							url: this.localUrl,
							web_uid: 'media_user_' + this.$cookies.get('user_id')
						},
						cache: {}
					}
					
					switch (type){
						case "zip":
							updateMethod = "updateSys"
							break;
						case "apk":
							updateMethod = "updateApk"
							dcObj.myData.fileLength = this.fileSize;
							break;
						default:
							break;
					}
					sendDeviceArr.push(dcObj);
				})
				sendCommandKp('multiple', sendDeviceArr, "get", {}, updateMethod);
				this.myWebSocket.onmessage = (val) =>{
					let data = JSON.parse(val.data);
					switch (data.type) {
						case "send_update_sys":
							this.updateData.forEach(ele=>{
								if(ele.sn == data.sn){
									this.$set(ele,"status",data.data.status)
									if(data.data.status == 4){
										let percent = Math.round(data.data.params.downloaded * 100)
										this.$set(ele,"percent",percent)
									}
								}
							})
							break;
						case "download_apk_process":
							this.updateData.forEach(ele=>{
								if(ele.sn == data.sn){
									ele.status = data.data.status;
									this.$set(ele,"status",data.data.status)
									if(data.data.status == 1) {
										console.log("percent",data.data.params.downloaded);
										let percent = (data.data.params.downloaded <= 100) ? Math.round(data.data.params.downloaded) : 100;
										this.$set(ele,"percent",percent)
										if(data.data.params.downloaded>=100){
											this.$set(ele,"status",3)
										}
									}
									if(data.data.status == 4 || data.data.status == 5) {
										this.$set(ele,"message",data.data.message);
									}
								}
							})
							break;
					}
				}
			},
			handlePreview() {
				let formData = {};
				let data = handleDataAndSign("/admin/device/uploadUpdatePackage", formData);
				//this.uploadFile.token = this.$cookies.get("token");
				this.uploadFile.v = data.v;
				this.uploadFile.t = data.t;
				this.uploadFile.token = data.token;
				this.uploadFile.s = data.s;
			},
			handle_success(data, file) {
				this.localUrl = data.data.url;
				//let index = this.localUrl.indexOf('local');
				//let localV = this.localUrl.slice(index + 6, this.localUrl.length - 4);
				this.local_new_version = file.name;
				this.fileSize = file.size;
				console.log('上传完成', file)
			},
			handleRemove(){
				this.localUrl = "";
			}
		},
		computed: {
			myWebSocket() {
				return this.$store.getters.myWebSocket;
			},
		},
		watch: {
			tableData() {
				console.log("watch", this.tableData)
				this.updateData = this.tableData
			}
		}
	}
</script>

<style lang="scss" scoped>
	.batch-update {
		display: flex;
		flex-direction: column;
		
		height: 500px;
		.formd-headerm,
		.formd-footer {
			width: 100%;
		}
		.rad{
			margin-left: 20px;
		}
		.upd{
			padding: 10px;
		}
		.upload-demo {
			display: flex;
			align-items: center;
		
			/deep/ .el-upload-list {
				height: 34px;
				margin-left: 40px;
				display: flex;
				align-items: center;
			}
		}
		.footer {
			width: 100%;
			display: flex;
			justify-content: space-around;
			padding-top: 10px;
			.bt-group{
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-around;
			}
		}
	}
</style>
